import { OutputEmail } from "./interface";
import { isOutputEmailSent } from "./reviewCtaUtils";

function OutputEmailStatusIndicator({ email, sentEmailIds, t }: {
  email: OutputEmail;
  sentEmailIds: Set<string>;
  t: (s: string) => string;
}) {
  if (!isOutputEmailSent(email, sentEmailIds)) return null;

  return (
    <span className="text-xs font-gilroy font-semibold text-blue shrink-0">
      {t("Sent")}
    </span>
  );
}

export default OutputEmailStatusIndicator;
